import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from "@angular/common";
import { RouterModule } from "@angular/router";
import { BusyModule, BusyConfig } from "angular2-busy";
import { NguiAutoCompleteModule } from "@ngui/auto-complete/dist";
import { NgxPaginationModule } from "ngx-pagination/dist/ngx-pagination";
import { MyDatePickerModule } from "mydatepicker";
import { PageStateService } from "./page-state.service";
import { AlertComponent } from "../../components/common/alert/alert.component";
import { ImageCropperModule } from "ng2-img-cropper";
import { LocalStorageModule } from "angular-2-local-storage/dist";
import { AddressService } from "./address.service";
import { TransactionLogManagementTableComponent } from "./transaction-log/transaction-log-management-table.component";
import { AuditReportTableComponent} from "./audit-report/audit-report-table.component";
import { DynamicFormModule } from "../dynamic-form/dynamic-form.module";
import { AutoMapperService } from "../../services/Common/auto-mapper.service";
import { RoleService } from "./role/role.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BootstrapSwitchModule } from 'angular2-bootstrap-switch';
import { DebounceDirective } from "./debounce.directive";

@NgModule({
    declarations: [
        AlertComponent,
        TransactionLogManagementTableComponent,
        AuditReportTableComponent,
        DebounceDirective,
        
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        DynamicFormModule,
        BusyModule.forRoot(new BusyConfig({
            template: `
            <div style="text-align:center;position:relative;height:100%;">
                <span style="font-size:100px;position:absolute;top:50%;height:100px;margin-top:-50px;" class="fa fa-spin fa-spinner"></span>
            </div>
            `,
            //minDuration: 90000
        })),
        NguiAutoCompleteModule,
        NgxPaginationModule,
        MyDatePickerModule,
        ImageCropperModule,
        LocalStorageModule.withConfig({
            prefix: 'my-app',
            storageType: 'localStorage'
        }),
        BootstrapSwitchModule.forRoot(),
        BrowserAnimationsModule
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        DynamicFormModule,
        BusyModule,
        NguiAutoCompleteModule,
        NgxPaginationModule,
        MyDatePickerModule,
        AlertComponent,
        ImageCropperModule,
        TransactionLogManagementTableComponent,
        AuditReportTableComponent,
        BootstrapSwitchModule,
        BrowserAnimationsModule,
        DebounceDirective
    ],
    providers: [
        DatePipe,
        PageStateService,
        AddressService,
        AutoMapperService,
        RoleService
    ]
})
export class AdminCommonModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/admin-common.module.ts